import accountServices from '../../../services/account'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import {signIn} from '@/utils/auth.js'
import {signOut} from '@/utils/auth.js'
export default {
    name: "SignIn",
    data() {
        return {
            payload: {},
            isUserConfirmed:false
        }
    },
    created(){
        console.clear();
        if (this.$route && this.$route.query.e) {
            this.payload = {    
                email: this.$route.query.e,
                code: this.$route.query.y,
                password: null,
                confirm_password: null,
            }
        } else {            
            this.$router.push({name: 'Login'})
        }
    },
    methods: {
        ConfirmCode() {
            Auth.confirmSignUp(this.payload.email, this.payload.code).then(data => {
                AmplifyEventBus.$emit('authState', 'signIn')
                console.clear();
                return data // 'SUCCESS'
              })
                .catch(err => {
                    console.clear();
                    //debugger
                    if(err.message == "User cannot be confirmed. Current status is CONFIRMED")
                    {
                        this._showToast("User account is already verified.", { variant: 'danger',title:'Error' })
                        this.isUserConfirmed = true
                    }
                });
        },
        getUser() {
            return Auth.currentAuthenticatedUser().then((user) => {
                console.clear();
              if (user && user.signInUserSession) {
                console.clear();
                return user
              } else {
                console.clear();
                return null
              }
            }).catch(err => {
                console.clear();
            });
          },
        UpdatePassword() {
            if(!this.isUserConfirmed)
            {
                this._loadingStart()
                //debugger
                this.ConfirmCode()
                console.clear();
                //debugger
                signIn(this.payload.email, 'Temp@321').then(user => {
                    console.clear();
                    //debugger
                    Auth.currentAuthenticatedUser()
                    .then(user => {
                        console.clear();
                        //debugger
                        return Auth.changePassword(user, 'Temp@321', this.payload.password);
                    })
                    .then(data => {
                        this._loadingEnd()
                        console.clear();
                        signOut()
                        this.$router.push({name: 'SuccessPage', params: {
                            title: 'Account Verified!',
                            subTitle: 'You have successfully updated the password',
                            icon:'far fa-check-circle'
                        }})
                    }
                        )
                    .catch(err => {
                        this._loadingEnd()
                        console.clear();
                        //debugger
                    });
                })
            }
            else
            {
                this._loadingEnd()
                console.clear();
                this._showToast("User account is already verified.", { variant: 'danger',title:'Error' })
            }
            
        },
        verifyAccount() {
            accountServices.verifyAccount(this.payload).then(resp => {
                if(!resp.error) {
                    this.$router.push({name: 'SuccessPage', params: {
                        title: 'Account Verified!',
                        subTitle: 'You have successfully updated the password',
                        icon:'far fa-check-circle'
                    }})
                }
            })
        }
    }
}